import { useCustomerDashboard } from "../CustomerDashboardContext"
import { WidgetsContainer } from "./styled"
import { DeviceDetailsWidget } from "./widgets/DeviceDetailsWidget"
import { PerformanceTestSnapshotWidget } from "./widgets/PerformanceTestSnapshotWidget"
import { RecentAlertsWidget } from "./widgets/RecentAlertsWidget"
import { SystemStatusSummaryWidget } from "./widgets/SystemStatusSummaryWidget"
import { TemperatureVsSetpointWidget } from "./widgets/TemperatureVsSetpointWidget"

export const CustomerDashboardOverview = () => {
  const { isSidebarOpen } = useCustomerDashboard()

  return (
    <WidgetsContainer sidebarOpen={isSidebarOpen}>
      <DeviceDetailsWidget />
      <TemperatureVsSetpointWidget />
      <SystemStatusSummaryWidget />
      <RecentAlertsWidget />
      <PerformanceTestSnapshotWidget />
    </WidgetsContainer>
  )
}
